const getKey = (item) => {
  const itemKey = Object.keys(item);
  return itemKey[0];
};

export default getKey;



// WEBPACK FOOTER //
// ./src/scripts/get-key.js